var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "materialScience" }, [
    _vm._m(0),
    _c("div", { staticClass: "cont" }, [
      _c("h1", { staticClass: "cont-title" }, [_vm._v("申报材料")]),
      _c("div", { staticClass: "tips" }, [
        _vm._v("注意：一共7项材料，按如下顺序准备好纸质材料。"),
      ]),
      _c("div", { staticClass: "cont-item" }, [
        _c("div", { staticClass: "item-title" }, [
          _vm._v("（一）学士学位申请登记表一份。"),
        ]),
        _c(
          "div",
          { staticClass: "imgs" },
          [
            _c("el-image", {
              staticClass: "img",
              attrs: {
                src: require("../../../assets/images/degreeApplication/application.jpg"),
                fit: "contain",
                "preview-src-list": [
                  require("../../../assets/images/degreeApplication/application.jpg"),
                ],
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "cont-item" }, [
        _c("div", { staticClass: "item-title" }, [
          _vm._v("（二）毕业证扫描件一份。"),
        ]),
        _c(
          "div",
          { staticClass: "imgs" },
          [
            _c("el-image", {
              staticClass: "img",
              attrs: {
                src: require("../../../assets/images/degreeApplication/diploma1.jpg"),
                fit: "contain",
                "preview-src-list": [
                  require("../../../assets/images/degreeApplication/diploma1.jpg"),
                  require("../../../assets/images/degreeApplication/diploma2.jpg"),
                ],
              },
            }),
            _c("el-image", {
              staticClass: "img",
              attrs: {
                src: require("../../../assets/images/degreeApplication/diploma2.jpg"),
                fit: "contain",
                "preview-src-list": [
                  require("../../../assets/images/degreeApplication/diploma1.jpg"),
                  require("../../../assets/images/degreeApplication/diploma2.jpg"),
                ],
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "cont-item" }, [
        _c("div", { staticClass: "item-title" }, [
          _vm._v("（三）英语考试如下材料之一："),
        ]),
        _c("div", { staticClass: "item-text" }, [
          _vm._v(
            "1、重庆市学位英语合格证书扫描件一份（2011年及以前参加考试的毕业生无需提交此项材料，不接受申报学位学校为其他院校的成绩）；"
          ),
        ]),
        _c("div", { staticClass: "item-text" }, [
          _vm._v(
            "2、高等教育自学考试本科段统考课程英语（二）成绩单扫描件或打印截图（重庆市外考生必须将成绩自行转至重庆市自考办并向我校自考办申请免试，TCL:023-62652910）；"
          ),
        ]),
        _c(
          "div",
          { staticClass: "imgs" },
          [
            _c("el-image", {
              staticClass: "img",
              attrs: {
                src: require("../../../assets/images/degreeApplication/englishAchievement.jpg"),
                fit: "contain",
                "preview-src-list": [
                  require("../../../assets/images/degreeApplication/englishAchievement.jpg"),
                ],
              },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "item-text" }, [
          _vm._v(
            "3、其它类英语考试合格证书或成绩单扫描件或扫描件（附准考证号、考试省市和年月备查）；"
          ),
        ]),
        _c(
          "div",
          { staticClass: "imgs" },
          [
            _c("el-image", {
              staticClass: "img",
              attrs: {
                src: require("../../../assets/images/degreeApplication/englishProgression.jpg"),
                fit: "contain",
                "preview-src-list": [
                  require("../../../assets/images/degreeApplication/englishProgression.jpg"),
                ],
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "cont-item" }, [
        _c("div", { staticClass: "item-title" }, [
          _vm._v(
            "（四）全国计算机等级考试（NCRE）合格证扫描件一份。（附考试时间、考试科目备查）"
          ),
        ]),
        _c(
          "div",
          { staticClass: "imgs" },
          [
            _c("el-image", {
              staticClass: "img",
              attrs: {
                src: require("../../../assets/images/degreeApplication/certificateConformity.jpg"),
                fit: "contain",
                "preview-src-list": [
                  require("../../../assets/images/degreeApplication/certificateConformity.jpg"),
                ],
              },
            }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "cont-item" }, [
        _c("div", { staticClass: "item-title" }, [
          _vm._v("毕业生总成绩单如下之一："),
        ]),
        _vm._m(1),
        _c(
          "div",
          { staticClass: "imgs" },
          [
            _c("el-image", {
              staticClass: "img",
              attrs: {
                src: require("../../../assets/images/degreeApplication/cjchengji.jpg"),
                fit: "contain",
                "preview-src-list": [
                  require("../../../assets/images/degreeApplication/cjchengji.jpg"),
                ],
              },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "item-text" }, [
          _vm._v(
            "2、自考毕业生成绩总表一份，成绩单扫描件需加盖鲜章(成绩单原件在档案袋里，由档案保存单位盖鲜章，例如档案在人才交流市场由该单位盖鲜章)。"
          ),
        ]),
        _c(
          "div",
          { staticClass: "imgs" },
          [
            _c("el-image", {
              staticClass: "img",
              attrs: {
                src: require("../../../assets/images/degreeApplication/schoolReport.jpg"),
                fit: "contain",
                "preview-src-list": [
                  require("../../../assets/images/degreeApplication/schoolReport.jpg"),
                ],
              },
            }),
          ],
          1
        ),
      ]),
      _vm._m(2),
      _vm._m(3),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "top" }, [
      _c("img", {
        staticClass: "materialScience-img",
        attrs: {
          src: require("../../../assets/images/degreeApplication/materialScience.png"),
          alt: "",
        },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "item-text" }, [
      _vm._v(" 1、成教毕业生成绩总表一份； "),
      _c(
        "a",
        {
          attrs: {
            href: "http://jxjycjcx.cqjtu.edu.cn/Account/Login?ReturnUrl=%2f",
            target: "_blank",
          },
        },
        [_c("span", { staticClass: "color-blue" }, [_vm._v("（成绩查询）")])]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "cont-item" }, [
      _c("div", { staticClass: "item-title" }, [
        _vm._v("（六）身份证复印件一份。"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "cont-item" }, [
      _c("div", { staticClass: "item-title" }, [
        _vm._v("（七）纸质小二寸照片2张（姓名及身份证号写背面），"),
      ]),
      _c("div", { staticClass: "item-tips" }, [
        _c("p", [_vm._v("注意：")]),
        _c("p", [
          _vm._v(" 1、纸质小2寸照片，必须与本科毕业证照片一致。（ "),
          _c("span", { staticClass: "color-red" }, [_vm._v("毕业证照片可在")]),
          _c(
            "a",
            { attrs: { href: "https://www.chsi.com.cn/", target: "_blank" } },
            [_c("span", { staticClass: "color-blue" }, [_vm._v("学信网")])]
          ),
          _c("span", { staticClass: "color-red" }, [_vm._v("上截取")]),
          _vm._v(" ） "),
        ]),
        _c("p", [
          _vm._v("2、电子照片（必须命名为 张 三 513132199210121028.jpg）， "),
          _c("span", { staticClass: "color-red" }, [
            _vm._v(
              "电子照片大小为10一40KB且像素尺寸为（宽）480*（高）640，图片必须用jpg格式"
            ),
          ]),
          _vm._v("。电子照片在网上申报时提交。"),
        ]),
        _c("p", [
          _vm._v(
            "3、申请学位所需电子照片格式不符合要求者，将无法完成学位信息网上报送工作！"
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }